"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailOtherTransaction = exports.DetailTransaction = void 0;
var React = require("react");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var Transactions_1 = require("@/pages/common/components/Transactions");
var react_redux_1 = require("react-redux");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var isMultiBuildings_1 = require("@/pages/common/transformers/isMultiBuildings");
var mapDetailStateToProps = function (state, ownProps) { return ({
    t: state.transactions.t,
    chartTitle: state.detail.property.building,
    transactions: state.transactions.transactions,
    resultT: state.resultT,
    symbolHkd: state.layout.currencies.options.find(function (it) { return it.key === SfilterPriceGroup_1.SfilterCurrency.HKD; }).symbol,
    lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1,
    hidden: ownProps.hidden,
}); };
var mapPropertyTransactionStateToProps = function (state, ownProps) {
    return ({
        t: state.otherTransactions.t,
        chartTitle: state.detail.property.building,
        transactions: state.otherTransactions.transactions,
        resultT: state.resultT,
        symbolHkd: state.layout.currencies.options.find(function (it) { return it.key === SfilterPriceGroup_1.SfilterCurrency.HKD; }).symbol,
        lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1,
        hidden: ownProps.hidden,
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    onChangePage: function (page) { return dispatch(DetailAction_1.default.onTransactionChangePage(page)); }
}); };
var mapTransactionDispatchToProps = function (dispatch) { return ({
    onChangePage: function (page) { return dispatch(DetailAction_1.default.onOtherTransactionChangePage(page)); }
}); };
var detailTransactions = function (props) {
    if (!props.transactions || !props.transactions.length)
        return React.createElement(React.Fragment, null);
    var multiBuildings = isMultiBuildings_1.isMultiBuildings(props.transactions);
    return (React.createElement("div", { className: "l-prop__transaction l-pad  l-pad-top--4", style: { display: props.hidden ? 'none' : '' } },
        React.createElement("div", { className: "l-pad" },
            React.createElement("div", { className: "o-h1 c-proptransaction__heading2" }, multiBuildings ? props.t.transactions : props.chartTitle + " - " + props.t.transactions)),
        React.createElement(Transactions_1.Transactions, { lang: props.lang, resultT: props.resultT, symbolHkd: props.symbolHkd })));
};
var detailOtherTransactions = function (props) {
    if (!props.transactions || !props.transactions.length)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "l-prop__other-transaction l-pad", style: { display: props.hidden ? 'none' : '' } },
        React.createElement("div", { className: "l-pad" },
            React.createElement("div", { className: "o-h1 c-proptransaction__heading2" }, props.t.otherTransactions)),
        React.createElement(Transactions_1.OtherTransactions, { lang: props.lang, resultT: props.resultT, symbolHkd: props.symbolHkd })));
};
exports.DetailTransaction = react_redux_1.connect(mapDetailStateToProps, mapDispatchToProps)(detailTransactions);
exports.DetailOtherTransaction = react_redux_1.connect(mapPropertyTransactionStateToProps, mapTransactionDispatchToProps)(detailOtherTransactions);
